import "./SinglePostTemplate.module.css"
import Navigation from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import AgencyFooter from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <Navigation />
      <SinglePostTemplateSection />
      <AgencyFooter />
    </div>
  )
}
